import React, {FunctionComponent} from "react";
import {Routes, Route, Navigate, useLocation} from "react-router-dom";
import {BackgroundColorContext} from "../contexts/BackgroundColorContext";
import {HelpProvider} from "../contexts/HelpContext";
import {SettingsProvider} from "../contexts/SettingsContext";
import {PaymentProvider} from "../contexts/PaymentContext";
import HelpModal from "../components/Help/HelpModal";
import SettingsModal from "../components/Settings/SettingsModal";

import Footer from "../components/Footer/Footer";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import Sidebar from "../components/Sidebar/Sidebar";

import routes from "../routes";

//@ts-ignore
import logo from "../assets/img/zwiftalizer-2-icon.png";
import ProtectedRoute from "../components/ProtectedRoute";
import GoogleAnalyticsWrapper from "../hooks/GoogleAnalyticsWrapper";
import AccessControl from "../components/AccessControl/AccessControl";
// Direct imports instead of lazy loading
import Upload from "../views/Upload";
import Report from "../views/Report";
import ReportPrivate from "../views/ReportPrivate";
import Files from "../views/Files";
import Search from "../views/Search";
import Benchmarks from "../views/Benchmarks";
import BenchmarkActivities from "../views/BenchmarkActivities";
import GpuProfiles from "../views/GpuProfiles";
import PingTest from "../views/PingTest";
import Terms from "../views/Terms";
import PrivacyNotice from "../views/PrivacyNotice";
import PurchaseSuccess from "../views/PurchaseSuccess";
import PurchaseCancel from "../views/PurchaseCancel";
import Homepage from "../views/Homepage";
import AdvancedAnalysisView from "../views/AdvancedAnalysisView";
import Contact from "../views/Contact";
import AboutUs from "../views/AboutUs";
import ShutdownNotice from "../views/ShutdownNotice";
import CookieConsentBanner from "../components/Common/CookieConsentBanner";

const AdminLayout: FunctionComponent = () => {
  const location = useLocation();
  const mainPanelRef = React.useRef(null);
  const [sidebarOpened, setsidebarOpened] = React.useState(
    document.documentElement.className.indexOf("nav-open") !== -1
  );

  // this function opens and closes the sidebar on small devices
  const toggleSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    setsidebarOpened(!sidebarOpened);
  };

  const getBrandText = () => {
    for (let i = 0; i < routes.length; i++) {
      const routePath = routes[i].path;
      if (routePath && location.pathname.indexOf(routePath) !== -1) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <PaymentProvider>
      <HelpProvider>
        <SettingsProvider>
          <AccessControl>
            <BackgroundColorContext.Consumer>
              {({color}) => (
                <React.Fragment>
                  <HelpModal />
                  <SettingsModal />
                  <div className="wrapper">
                    <Sidebar
                      routes={routes}
                      logo={{
                        innerLink: "/",
                        text: "TrainerDX",
                        imgSrc: logo
                      }}
                      toggleSidebar={toggleSidebar}
                    />
                    <div className="main-panel" ref={mainPanelRef} data-color={color}>
                      <AdminNavbar
                        brandText={getBrandText()}
                        toggleSidebar={toggleSidebar}
                        sidebarOpened={sidebarOpened}
                      />
                      <div className="content">
                        <GoogleAnalyticsWrapper>
                          <Routes>
                            <Route path="/" element={<Homepage />} />
                            <Route path="/logreport/:id" element={<ReportPrivate />} />
                            <Route path="/report/:id" element={<Report />} />
                            <Route path="/upload" element={<Upload />} />

                            <Route
                              path="/benchmarks/:world?/:profile?/:resolution?/:crowd?/:year?/:quarter?"
                              element={<Benchmarks />}
                            />
                            <Route
                              path="/benchmarkactivities/:world?/:profile?/:resolution?/:cpu?/:gpu?/:year?/:quarter?"
                              element={<BenchmarkActivities />}
                            />
                            <Route path="/gpu-profiles" element={<GpuProfiles />} />
                            <Route path="/ping" element={<PingTest />} />
                            <Route path="/search/:query?" element={<Search />} />
                            <Route path="/termsofuse" element={<Terms />} />
                            <Route path="/privacy" element={<PrivacyNotice />} />
                            <Route path="/files" element={<Files />} />
                            <Route
                              path="/analysis/:logId"
                              element={<ProtectedRoute component={AdvancedAnalysisView} />}
                            />
                            <Route path="/tokens/purchase" element={<Navigate to="/shutdown" replace />} />
                            <Route path="/purchase/success" element={<ProtectedRoute component={PurchaseSuccess} />} />
                            <Route path="/purchase/cancel" element={<ProtectedRoute component={PurchaseCancel} />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/about" element={<AboutUs />} />
                            <Route path="/shutdown" element={<ShutdownNotice />} />
                          </Routes>
                        </GoogleAnalyticsWrapper>
                      </div>
                      <Footer />
                    </div>
                  </div>
                  <CookieConsentBanner
                    location="bottom"
                    buttonText="OK"
                    cookieName="CookieConsent"
                    style={{background: "#fc6719"}}
                    buttonStyle={{color: "#000", fontSize: "13px", borderRadius: "5px"}}
                    expires={150}
                  >
                    This site uses cookies. By continuing to browse the site, you are agreeing to our use of cookies.
                  </CookieConsentBanner>
                </React.Fragment>
              )}
            </BackgroundColorContext.Consumer>
          </AccessControl>
        </SettingsProvider>
      </HelpProvider>
    </PaymentProvider>
  );
};

export default AdminLayout;
